<template>
  <div class="main">
    <!-- 头部 -->
    <div class="banner">
      <!-- <img
        src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6255572dd65b4/277686848.png"
      /> -->
      <video muted autoplay="autoplay" loop="loop" src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/guanwang/index_3d_10s.mp4"></video>
      <div class="cover">
        <div class="list" v-for="item of banner" :key="item.title" :style="{left: item.left, top: item.top}" @click="goDetail(item.url)">
          <div class="point"></div>
          <div class="content">
            <img
              :src="item.icon"
              alt=""
            />
            <span>{{ item.title }}</span>
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6257d244cc7c3/574231217.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 头部icon -->
    <div class="indexHeader">
      <img
        src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_62555745588aa/448535079.png"
        alt=""
      />
    </div>
    <div></div>
    <!-- 重点 -->
    <div class="emphasis">
      <div>
        <div class="list">
          <img
            src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_625936d70ba6a/368715858.png"
            alt=""
          />
          <span>虚仿教学基地建设</span>
        </div>
        <div class="list">
          <img
            src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624ff56b9bc21/425302735.png"
            alt=""
          />
          <span>虚拟仿真“金课”建设</span>
        </div>
        <div class="list">
          <img
            src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624ff56b76d8e/454915880.png"
            alt=""
          />
          <span>虚拟教研室建设试点</span>
        </div>
      </div>
      <div>
        <div class="list">
          <img
            src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624ff56b8fbaa/740635765.png"
            alt=""
          />
          <span>教育部产学协同育人</span>
        </div>
        <div class="list" style="margin-left: -30px">
          <img
            src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624ff56b7471d/717226827.png"
            alt=""
          />
          <span>新城市文旅</span>
        </div>
        <div class="list">
          <img
            src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_625936d6d3d24/653517543.png"
            alt=""
          />
          <span>新数字景区</span>
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
    <div class="plan">
      <div>
        <div class="headline">解决方案</div>
        <div class="description">用XR技术为行业客户提供各种场景下的实训</div>
        <div class="content">
          <div class="list" v-for="item of plan" :key="item.name">
            <img v-lazy="item.setting.imageurl" :key="item.setting.imageurl" />
            <div class="title">{{ item.name }}</div>
            <div class="desc">{{ item.setting.alt }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 最新动态 -->
    <div class="news">
      <div class="headline">
        <!-- <img
          src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/index/29.png"
          alt=""
        /> -->
        <span>最新动态</span>
      </div>
      <div class="content">
        <swiper :options="swiperOption" ref="mySwiper" class="mySwiper">
          <swiper-slide class="slide" v-for="item of news" :key="item.name">
            <div @click="go('newsDetail', item.setting.linkurl)">
              <img :src="item.setting.imageurl" />
              <div class="desc">
                <div class="title">{{ item.name }}</div>
                <div class="time">{{ item.setting.alt }}</div>
              </div>
            </div>
          </swiper-slide>
          <!-- <div class="swiper-pagination" slot="pagination"></div> -->
          <!-- <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>
      </div>
    </div>
    <!-- 行业案例 -->
    <div class="case">
      <div class="headline">行业案例</div>
      <div class="desc">成功实施落地近千个项目案例</div>
      <div class="content">
        <div class="three">
          <div class="list" v-for="item of caseTop" :key="item.name">
            <img :src="item.setting.imageurl" alt="" />
            <span class="title">{{ item.name }}</span>
          </div>
        </div>
        <div class="two">
          <div class="list" v-for="item of caseDown" :key="item.name">
            <img :src="item.setting.imageurl" alt="" />
            <span class="title">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="more" @click="go('customerStories')">
        <span>查看更多案例</span>
        <img
          src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/60.png"
          alt=""
        />
      </div>
    </div>

    <!-- 飘窗 -->
    <!-- <img id="flutter" @click="goWithout('https://mp.weixin.qq.com/s/KEhBXH_Hn32sELLq46uSnA')" src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/educate.png" alt=""> -->
    <!-- <img id="isMobile" class="flutterMobile" @click="goWithout('https://mp.weixin.qq.com/s/KEhBXH_Hn32sELLq46uSnA')" src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/educateMobile.png" alt=""> -->
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import { index } from '@/services/api';

export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      banner: [
        {
          title: '能源电力',
          url: '4',
          icon: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_62593c550c500/885863685.png',
          left: '27%',
          top: '11%'
        },
        {
          title: '智慧工厂',
          url: '3',
          icon: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_62593c54623d7/712637551.png',
          left: '22%',
          top: '23%'
        },
        {
          title: '汽修实训',
          url: '7',
          icon: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_62593c5427acc/728215749.png',
          left: '41%',
          top: '13%'
        },
        {
          title: '高端制造',
          url: '10',
          icon: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_625f81c7efc29/270531147.png',
          left: '51%',
          top: '31%'
        },
        {
          title: '医护实训',
          url: '6',
          icon: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_62593c548df99/821267875.png',
          left: '26%',
          top: '48%'
        },
        {
          title: '工程建筑',
          url: '2',
          icon: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_62593c54efd21/715494036.png',
          left: '80.5%',
          top: '73%'
        }
      ],
      swiperOption: {
        loop: true,
        effect: 'coverflow',
        slidesPerView: 1.3,
        centeredSlides: true,
        initialSlide: 0,
        coverflowEffect: {
          rotate: 0,
          stretch: 10,
          depth: 160,
          modifier: 2,
          slideShadows: true
        },
        autoplay: {
          delay: 3000, // 秒
          stopOnLastSlide: false,
          disableOnInteraction: false // 滑动不会失效
        },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        pagination: {
          el: '.swiper-pagination'
        }
        // observeParents: true,
        // pagination: '.swiper-pagination',
        // paginationClickable: true, // 分页可点击
        // slidesPerView: 1, // 每次滑动图片一张
        // slidesPerGroup: 1, // 每个div只有一张图片
        // loop: true, // false 不循环    true循环
        // // grabCursor: true,	//鼠标光标
        // autoplay: {
        //   delay: 2000, // 秒
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false // 滑动不会失效
        // }
        // 其他的所有的参数同 swiper 官方 api 参数
      },
      plan: [],
      news: [],
      caseTop: [],
      caseDown: []
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    // this.initFlutter();
    this.getData();
    window.onscroll = () => {
      this.showHeader();
    };
  },
  methods: {
    imgUrl(num) {
      return (
        'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/' +
        num +
        '.png'
      );
    },
    getData() {
      index().then(res => {
        const data = res.data.list;
        this.plan = data.jiejue_fangan;
        this.news = data.zuixin_dongtai;
        this.caseTop = data.anli_top;
        this.caseDown = data.anli_down;
        this.$nextTick(() => {
          this.$refs.mySwiper.mountInstance();
        });
      });
    },
    goDetail(id) {
      this.go('plan', id)
    },
    go(name, id, anchor) {
      this.$router.push({
        path: '/' + name,
        query: {
          id
        }
      });
    },
    goWithout(url) {
      window.open(url);
    },
    callback() {},
    // 飘窗
    initFlutter() {
      //   var AdMoveConfig = new Object();
      //   AdMoveConfig.IsInitialized = false;
      //   AdMoveConfig.ScrollX = 0;
      //   AdMoveConfig.ScrollY = 0;
      //   AdMoveConfig.MoveWidth = 0;
      //   AdMoveConfig.MoveHeight = 0;
      //   AdMoveConfig.Resize = function() {
      //     var winsize = GetPageSize();
      //     AdMoveConfig.MoveWidth = winsize[2];
      //     AdMoveConfig.MoveHeight = winsize[3];
      //     AdMoveConfig.Scroll();
      //   };
      //   AdMoveConfig.Scroll = function() {
      //     var winscroll = getPageScroll();
      //     AdMoveConfig.ScrollX = winscroll[0];
      //     AdMoveConfig.ScrollY = winscroll[1];
      //   };
      //   function getPageScroll() {
      //     var xScroll, yScroll;
      //     if (self.pageXOffset) {
      //       xScroll = self.pageXOffset;
      //     } else if (
      //       document.documentElement &&
      //       document.documentElement.scrollLeft
      //     ) {
      //       xScroll = document.documentElement.scrollLeft;
      //     } else if (document.body) {
      //       xScroll = document.body.scrollLeft;
      //     }
      //     if (self.pageYOffset) {
      //       yScroll = self.pageYOffset;
      //     } else if (
      //       document.documentElement &&
      //       document.documentElement.scrollTop
      //     ) {
      //       yScroll = document.documentElement.scrollTop;
      //     } else if (document.body) {
      //       yScroll = document.body.scrollTop;
      //     }
      //     let arrayPageScroll = new Array(xScroll, yScroll)
      //     return arrayPageScroll;
      //   }
      //   function AdMove(id) {
      //     if (!AdMoveConfig.IsInitialized) {
      //       AdMoveConfig.Resize();
      //       AdMoveConfig.IsInitialized = true;
      //     }
      //     var obj = document.getElementById(id);
      //     obj.style.position = 'fixed';
      //     var W = AdMoveConfig.MoveWidth - obj.offsetWidth;
      //     var H = AdMoveConfig.MoveHeight - obj.offsetHeight;
      //     var x = W * Math.random();
      //     var y = H * Math.random();
      //     var rad = ((Math.random() + 1) * Math.PI) / 6;
      //     var kx = Math.sin(rad);
      //     var ky = Math.cos(rad);
      //     var dirx = Math.random() < 0.5 ? 1 : -1;
      //     var diry = Math.random() < 0.5 ? 1 : -1;
      //     var step = 1;
      //     var interval;
      //     this.SetLocation = function(vx, vy) {
      //       x = vx;
      //       y = vy;
      //     };
      //     this.SetDirection = function(vx, vy) {
      //       dirx = vx;
      //       diry = vy;
      //     };
      //     obj.CustomMethod = function() {
      //       // console.log(y, AdMoveConfig.ScrollY)
      //       obj.style.left = x + AdMoveConfig.ScrollX + 'px';
      //       obj.style.top = y + AdMoveConfig.ScrollY + 'px';
      //       rad = ((Math.random() + 1) * Math.PI) / 6;
      //       W = AdMoveConfig.MoveWidth - obj.offsetWidth;
      //       H = AdMoveConfig.MoveHeight - obj.offsetHeight;
      //       x = x + step * kx * dirx;
      //       if (x < 0) {
      //         dirx = 1;
      //         x = 0;
      //         kx = Math.sin(rad);
      //         ky = Math.cos(rad);
      //       }
      //       if (x > W) {
      //         dirx = -1;
      //         x = W;
      //         kx = Math.sin(rad);
      //         ky = Math.cos(rad);
      //       }
      //       y = y + step * ky * diry;
      //       if (y < 0) {
      //         diry = 1;
      //         y = 0;
      //         kx = Math.sin(rad);
      //         ky = Math.cos(rad);
      //       } else if (document.documentElement.scrollTop === 0 && y < 80) {
      //         diry = 1;
      //         y = 80;
      //         kx = Math.sin(rad);
      //         ky = Math.cos(rad);
      //       } else if (y > H) {
      //         diry = -1;
      //         y = H;
      //         kx = Math.sin(rad);
      //         ky = Math.cos(rad);
      //       }
      //     };
      //     this.Run = function() {
      //       var delay = 10;
      //       interval = setInterval(obj.CustomMethod, delay);
      //       obj.onmouseover = function() {
      //         clearInterval(interval);
      //       };
      //       obj.onmouseout = function() {
      //         interval = setInterval(obj.CustomMethod, delay);
      //       };
      //     };
      //   }
      //   function GetPageSize() {
      //     var xScroll, yScroll;
      //     if (window.innerHeight && window.scrollMaxY) {
      //       xScroll = document.body.scrollWidth;
      //       yScroll = window.innerHeight + window.scrollMaxY;
      //     } else if (document.body.scrollHeight > document.body.offsetHeight) {
      //       xScroll = document.body.scrollWidth;
      //       yScroll = document.body.scrollHeight;
      //     } else {
      //       xScroll = document.body.offsetWidth;
      //       yScroll = document.body.offsetHeight;
      //     }
      //     var windowWidth, windowHeight;
      //     if (self.innerHeight) {
      //       windowWidth = self.innerWidth;
      //       windowHeight = self.innerHeight;
      //     } else if (
      //       document.documentElement &&
      //       document.documentElement.clientHeight
      //     ) {
      //       windowWidth = document.documentElement.clientWidth;
      //       windowHeight = document.documentElement.clientHeight;
      //     } else if (document.body) {
      //       windowWidth = document.body.clientWidth;
      //       windowHeight = document.body.clientHeight;
      //     }
      //     let pageHeight;
      //     let pageWidth;
      //     if (yScroll < windowHeight) {
      //       pageHeight = windowHeight;
      //     } else {
      //       pageHeight = yScroll;
      //     }
      //     if (xScroll < windowWidth) {
      //       pageWidth = windowWidth;
      //     } else {
      //       pageWidth = xScroll;
      //     }
      //     let arrayPageSize = new Array(
      //       pageWidth,
      //       pageHeight,
      //       windowWidth,
      //       windowHeight
      //     );
      //     return arrayPageSize;
      //   }
      //   var flutter = new AdMove('flutter');
      //   flutter.Run();
    },
    showHeader() {
      // 为了保证兼容性，这里取两个值，哪个有值取哪一个
      // scrollTop就是触发滚轮事件时滚轮的高度
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (this.$route.name !== 'index') return;
      if (scrollTop < 10) {
        this.$store.commit('SetShowHeader', false);
        if (document.getElementById('nb-icon-base')) {
          console.log(document.getElementById('nb-icon-base'))
          document.getElementById('nb-icon-base').style.display = 'none'
        }
      } else {
        this.$store.commit('SetShowHeader', true);
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .van-swipe__indicator {
  width: 30px;
  height: 4px;
  border-radius: 2px;
  margin-right: 30px;
}
/deep/ .swiper-pagination-bullet {
  border-radius: 2px;
  background: none;
  border: 2px solid #f27529;
}
/deep/ .swiper-pagination-bullet-active {
  background: #f27529;
}
.swiper-container {
  pointer-events: none;
}
@keyframes boderM {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  75% {
    transform: translate(-50%, -50%) scale(2);
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@keyframes bordershow {
  50% {
    box-shadow: 0px 0px 10px 2px #FFD302;
  }
}
.main {
  background: #fff;
  //banner设计
  .banner {
    position: relative;
    margin-top: -80px;
    > video {
      width: 100%;
    }
    .cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .list {
        position: absolute;
        left: 80%;
        top: 26%;
        display: flex;
        align-items: center;
        cursor: pointer;
        .point {
          position: relative;
          z-index: 2;
          width: 18px;
          height: 18px;
          background: #fff;
          border: 7px solid #FFD302;
          border-radius: 50%;
          animation: bordershow 3s infinite;
        }
        .point::before {
          content: "";
          display: block;
          position: absolute;
          left: 50%;
          top: 50%;
          z-index: -1;
          transform: translate(-50%, -50%);
          width: 25px;
          height: 25px;
          border-radius: 50%;
          background: rgba(255,211,2, 0.3);
        }

        .point::after {
          content: "";
          display: block;
          position: absolute;
          left: 50%;
          top: 50%;
          z-index: -1;
          transform: translate(-50%, -50%);
          width: 25px;
          height: 25px;
          border-radius: 50%;
        }
        .point::before {
          animation: boderM 3s 1.75s infinite;
        }

        .point::after {
          animation: boderM 3s infinite;
        }
        .content {
          opacity: 0;
          max-width: 0px;
          height: 41px;
          background: linear-gradient(244deg, #F68C44 0%, #FFB350 100%);
          box-shadow: 0px 0px 10px -2px rgba(133, 133, 133, 0.66);
          border-radius: 28px;
          margin-left: 14px;
          overflow: hidden;
          transition: all 0.4s cubic-bezier(0.25,0.1,0.25,1);
          position: relative;
          z-index: 2;
          // flex-wrap: wrap;
          // display: flex;
          // align-items: center;
          // padding: 10px 0;
          img:nth-child(1) {
            width: 16px;
            height: 16px;
            margin-left: 14px;
            line-height: 41px;
            vertical-align: middle;
          }
          img:nth-child(3) {
            width: 16px;
            height: 16px;
            margin-right: 16px;
            margin-left: 18px;
            vertical-align: middle;
            line-height: 41px;
          }
          span {
            flex: 1;
            padding: 0px 0px 0 6px;
            font-size: 18px;
            font-weight: 600;
            color: #ffffff;
            line-height: 41px;
            // width: 100px;
            display: inline-block;
            box-sizing: border-box;
            word-break: keep-all;
            vertical-align: middle;
          }
        }
      }
      .list:hover .content {
        max-width: 200px;
        opacity: 1;
      }
    }
  }
  .indexHeader {
    display: flex;
    position: fixed;
    top: 0;
    left: 50%;
    width: 1200px;
    margin-left: -596px;
    align-items: center;
    height: 80px;
    img {
      height: 48px;
    }
  }
  .emphasis {
    width: 1000px;
    margin: 0 auto;
    padding: 100px 0 0 0;
    > div{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 95px;
      .list {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        img {
          width: 121px;
          margin-bottom: 22px;
        }
        span {
          font-size: 18px;
          font-weight: 500;
          color: #202122;
          line-height: 25px;
        }
      }
    }
  }
  .plan {
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/backgroundImg/index_fangan.png);
    background-size: 100% 100%;
    width: 100%;
    > div {
      width: 1230px;
      height: auto;
      margin: 0 auto;
      padding-bottom: 45px;
      padding-top: 1px;
      .headline {
        text-align: center;
        margin: 53px auto 12px auto;
        font-size: 28px;
        font-weight: 600;
        color: #000000;
        line-height: 40px;
      }
      .description {
        text-align: center;
        margin: 0 auto;
        margin-bottom: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #707483;
        line-height: 20px;
      }
      .content {
        display: flex;
        flex-wrap: wrap;
        .list {
          width: 408px;
          height: 430px;
          position: relative;
          margin-right: 2px;
          margin-bottom: 5px;
          > img {
            width: 100%;
            height: 100%;
            display: block;
          }
          .title {
            position: absolute;
            top: 323px;
            left: 41px;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            line-height: 22px;
          }
          .desc {
            position: absolute;
            top: 351px;
            left: 41px;
            font-size: 14px;
            font-weight: 400;
            color: #ffffff;
            line-height: 20px;
            word-break: break-all;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 331px;
          }
        }
        .list:nth-child(3n) {
          margin-right: 0;
        }
      }
      .more {
        margin-top: 32px;
        display: flex;
        justify-content: center;
        cursor: pointer;
        span {
          font-size: 14px;
          font-weight: 500;
          color: #444a62;
          line-height: 17px;
        }
        img {
          width: 13px;
          height: 11px;
          margin-left: 6px;
          margin-top: 2px;
        }
      }
    }
  }
  .news {
    // background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/index/28.png);
    // background-size: 100% 100%;
    padding: 0 100px;
    padding-bottom: 30px;
    // width: 100%;
    // max-width: 2000px;
    .headline {
      width: 1200px;
      margin: 0 auto;
      position: relative;
      // height: 139px;
      padding-top: 1px;
      text-align: center;
      padding-bottom: 62px;
      img {
        position: absolute;
        left: 0;
        top: 38px;
        width: 119px;
      }
      span {
        margin-top: 63px;
        display: block;
        font-size: 28px;
        font-weight: 600;
        color: #000000;
        line-height: 40px;
      }
    }
    .mySwiper {
      // width: 1300px;
      // height: 420px;
      width: 100%;
      height: 570px;
    }
    .slide {
      width: 600px;
      height: 500px;
      border-radius: 10px;
      overflow: hidden;
      > div {
        width: 100%;
        height: 100%;
        position: relative;
        cursor: pointer;
        pointer-events: none;
        > img {
          width: 100%;
          height: 100%;
          position: absolute;
          object-fit: cover;
          pointer-events: auto;
        }
        .desc {
          width: 100%;
          height: 176px;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.61) 100%
          );
          border-radius: 8px;
          position: absolute;
          left: 0;
          bottom: 0;
          .title {
            width: 100%;
            text-align: center;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            line-height: 22px;
            margin-top: 100px;
          }
          .time {
            width: 100%;
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            color: #ffffff;
            line-height: 17px;
            margin-top: 12px;
          }
        }
      }
    }
  }
  .case {
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/backgroundImg/index_anli.png);
    background-size: 100% 100%;
    padding-top: 54px;
    .headline {
      font-size: 28px;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
      text-align: center;
    }
    .desc {
      font-size: 14px;
      font-weight: 400;
      color: #707483;
      line-height: 20px;
      text-align: center;
      padding-top: 12px;
    }
    .content {
      width: 1200px;
      margin: 0 auto;
      padding-top: 54px;
      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .three {
        margin-bottom: 30px;
        .list {
          width: 380px;
          height: 420px;
          background: #fff;
          border-radius: 19px;
          overflow: hidden;
          > img {
            width: 100%;
            height: 324px;
            display: block;
            object-fit: cover;
          }
          .title {
            display: block;
            line-height: 96px;
            text-align: center;
            font-size: 22px;
            font-weight: 400;
            color: #000000;
          }
        }
      }
      .two {
        .list {
          width: 585px;
          height: 420px;
          background: #fff;
          border-radius: 19px;
          overflow: hidden;
          > img {
            width: 100%;
            height: 324px;
            display: block;
            object-fit: cover;
          }
          .title {
            display: block;
            line-height: 96px;
            text-align: center;
            font-size: 22px;
            font-weight: 400;
            color: #000000;
          }
        }
      }
    }
    .more {
      padding: 61px 0 61px 0;
      display: flex;
      justify-content: center;
      cursor: pointer;
      span {
        font-size: 14px;
        font-weight: 500;
        color: #444a62;
        line-height: 17px;
      }
      img {
        width: 13px;
        height: 11px;
        margin-left: 6px;
        margin-top: 2px;
      }
    }
  }
}
@media (max-width: 1000px) {
  /deep/ .van-swipe__indicator {
    width: 36px;
    border-radius: 6px;
  }
  .main {
    .banner {
      width: 100%;
      height: auto;
      margin-top: -96px;
      .cover {
        .list {
          display: none;
        }
      }
    }
    .indexHeader {
      display: none;
    }
    .emphasis {
      width: 100%;
      padding: 60px 48px 0;
      box-sizing: border-box;
      > div {
        flex-wrap: wrap;
        justify-content: space-between;
        padding-bottom: 0;
        .list {
          width: 32%;
          margin-bottom: 60px;
          margin-left: 0 !important;
          img {
            width: 80px;
            margin-bottom: 16px;
          }
          span {
            font-size: 24px;
            text-align: center;
            line-height: 36px;
          }
        }
      }
    }
    .plan {
      overflow: hidden;
      > div {
        width: 100%;
        padding: 0 48px 60px;
        box-sizing: border-box;
        .headline {
          font-size: 36px;
          margin: 60px auto 12px;
        }
        .description {
          font-size: 24px;
        }
        .content {
          .list {
            width: 100%;
            height: 320px;
            margin-right: 0;
            margin-bottom: 26px;
            // img{
            //   object-fit: cover;
            //   border-radius: 10px;
            // }
            .title {
              font-size: 28px;
              top: 200px;
              left: 34px;
            }
            .desc {
              top: 236px;
              left: 34px;
              font-size: 22px;
              width: calc(100% - 48px);
              line-height: 36px;
            }
          }
          .list:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
    .news {
      padding: 0 48px 30px;
      .headline {
        width: 100%;
        padding-bottom: 40px;
        span {
          margin-top: 40px;
          font-size: 36px;
        }
      }
      .mySwiper {
        height: 400px;
      }
      .slide {
        width: 90%;
        height: 360px;
        > div {
          .desc {
            .title {
              font-size: 28px;
              margin-top: 80px;
              line-height: 36px;
            }
            .time {
              font-size: 22px;
            }
          }
        }
      }
    }
    .case {
      padding-top: 60px;
      .headline {
        font-size: 36px;
      }
      .desc {
        font-size: 24px;
      }
      .content {
        width: 100%;
        padding: 40px 48px 0;
        box-sizing: border-box;
        .three,
        .two {
          flex-direction: column;
          align-items: center;
          margin-bottom: 0;
          .list {
            width: 100%;
            height: auto;
            margin-bottom: 24px;
            > img {
              height: 280px;
            }
            .title {
              line-height: 80px;
              font-size: 28px;
            }
          }
        }
      }
      .more {
        padding: 40px 0;
        span {
          font-size: 28px;
        }
      }
    }
  }
}
</style>
